import { render } from "./ChecklistPage.vue?vue&type=template&id=5cdd974f&scoped=true"
import script from "./ChecklistPage.vue?vue&type=script&lang=js"
export * from "./ChecklistPage.vue?vue&type=script&lang=js"

import "./ChecklistPage.vue?vue&type=style&index=0&id=5cdd974f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdd974f"]])

export default __exports__